var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondBoxCrystal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-66f70afd-b805-4d6a-adbe-1a11d55f15f4",
    "data-name": "uuid-8788c5d3-7126-465f-b95b-5d780c01ad61",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.44433 194.86055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-bc5c2465-0116-4f55-a3d6-ea16dea96835",
    "data-name": "uuid-c7956a33-ea79-4b5b-ad19-331d2c8df04a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.32753,
    y: 30.53667,
    width: 133.78722,
    height: 133.78721,
    transform: "translate(-38.07505 102.93925) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.8453 124.2321 190.64531 97.4321 163.8453 70.6321 132.00531 38.8021 114.39531 21.1921 96.04531 21.1921 78.43531 38.8021 46.59531 70.6321 19.79531 97.4321 46.59531 124.2321 78.42531 156.05209 96.04531 173.6721 114.39531 173.6721 132.0153 156.05209 163.8453 124.2321",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.59531 135.0587 46.59531 156.05209 67.5953 156.05209",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "67.5953 38.8021 46.59531 38.8021 46.59531 59.7955",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "163.8775 59.7312 163.8775 38.7378 142.8775 38.7378",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.84541 135.0587 163.84541 156.05209 142.84541 156.05209 163.84541 135.0587",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.3377,
    y: 90.9321,
    width: 13.00002,
    height: 13.00002,
    transform: "translate(-10.36379 169.8438) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.10661,
    y: 90.90969,
    width: 13.00002,
    height: 13.00002,
    transform: "translate(-65.77246 36.03065) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.16965,61.47627c-.05778,.17972-.09049,.37267-.17695,.53727-3.46632,6.59877-6.93729,13.19508-10.40939,19.7908-.07783,.14785-.17558,.28517-.29843,.48271-.17487-.28887-.32579-.52728-.46622-.77176-3.71312-6.46468-7.42536-12.92987-11.1365-19.3957-.12087-.21059-.22865-.42871-.34254-.64332h22.83002Z",
    fill: "#f9d089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.09738,61.47627c-3.29275,5.75029-6.58528,11.50071-9.87846,17.25076-.66564,1.16224-1.33376,2.32306-2.04052,3.55379-.12815-.18721-.24201-.32266-.3226-.4757-3.4732-6.59565-6.94406-13.19254-10.41047-19.79177-.08651-.1647-.11985-.35742-.17798-.53708,7.61,0,15.22002,0,22.83002,0Z",
    fill: "#f9d089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35324,86.14799h23.0816c4.05271,16.24145,8.11166,32.50794,12.17062,48.77443-.03829,.01958-.07657,.03915-.11486,.05872-11.69189-16.24914-23.38378-32.49828-35.13736-48.83315Z",
    fill: "#f9d089"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.83104,134.92509c4.05411-16.24853,8.10822-32.49705,12.17024-48.77726h23.08442c-11.74902,16.32872-23.44253,32.58031-35.13604,48.83189-.03954-.01821-.07908-.03641-.11862-.05462h0Z",
    fill: "#f9d089"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.12612,131.34367c-3.75305-15.04135-7.5061-30.0827-11.27428-45.18472h22.73267c-3.76035,15.0725-7.51616,30.1268-11.27197,45.18111-.06214,.00121-.12428,.0024-.18642,.00361h0Z",
    fill: "#f9d089"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.38719,83.72938h-22.18565c3.34222-7.07052,6.65241-14.07328,10.01915-21.19567,4.07978,7.10752,8.10242,14.1155,12.1665,21.19567Z",
    fill: "#f9d089"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.24278,83.74262h-22.19883c4.06483-7.08228,8.08865-14.09312,12.17255-21.20862,3.36231,7.11229,6.67188,14.11305,10.02628,21.20862Z",
    fill: "#f9d089"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.21886,62.82019c3.70826,7.04795,7.33606,13.94296,11.0003,20.90725h-22.00057c3.66346-6.96282,7.29133-13.85798,11.00027-20.90725Z",
    fill: "#f9d089"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondBoxCrystal);
export default __webpack_public_path__ + "static/media/diamond-box-crystal.2d7dffddc53b9f6e4aa0956892ebb145.svg";
export { ForwardRef as ReactComponent };